import { GridPostParams, GridModel } from "common/models/utility-models/list-utility.model";
import { MentorModel } from "../mentor/mentor-data-model";

export class MentorLogsParams extends GridPostParams { }

export class MentorLogsGridModel extends MentorModel { }

export class MentorLogsListingModel extends GridModel<MentorLogsGridModel> { }